import { MediaRoomState } from './types';

import { AGORA } from '@/constants';
import { RootState } from '@/store';

const getters = {
  virtualBackgrounds(state: MediaRoomState, getters: any, rootState: RootState) {
    const themeObject = rootState.event.event.theme_obj || {};
    const virtualBackgrounds = themeObject.virtual_backgrounds || [];
    if (Array.isArray(virtualBackgrounds)) {
      return virtualBackgrounds;
    }
    if (typeof virtualBackgrounds === 'string') {
      return [virtualBackgrounds];
    }
    return [];
  },
  currentMediaRoom(state: MediaRoomState) {
    const mainStageId = Object.keys(state.mediaRooms).find(key => !key.includes(AGORA.UID_SUFFIX.BACKSTAGE));
    const id = mainStageId ?? Object.keys(state.mediaRooms)[0];
    const currentMediaRoom = state.mediaRooms[id];

    if (!currentMediaRoom) {
      return null;
    }

    return currentMediaRoom;
  },
  isAnyoneOnStage(state: MediaRoomState, getters: any, rootState: RootState) {
    const mainStageMediaRoomId = Object.keys(state.mediaRooms).find(key => !key.includes(AGORA.UID_SUFFIX.BACKSTAGE));
    const isCurrentUserOnStage = state.mediaRooms[mainStageMediaRoomId ?? '']?.userRole === 'host';
    const hasRemoteStreams = Object.keys(state.mediaRooms[mainStageMediaRoomId ?? '']?.remoteStreams || {}).length > 0;
    return isCurrentUserOnStage || hasRemoteStreams;
  },
  isCurrentUserOnStage(state: MediaRoomState) {
    const mainStageMediaRoomId = Object.keys(state.mediaRooms).find(key => !key.includes(AGORA.UID_SUFFIX.BACKSTAGE));
    return state.mediaRooms[mainStageMediaRoomId ?? '']?.userRole === 'host';
  }
};

export default getters;
export type MediaRoomGetters = typeof getters;
